import React from 'react';
import { ReactComponent as WaterLogo } from 'assets/icons/ui-icon-utility-16-water.svg';
import { ReactComponent as ElectricityLogo } from 'assets/icons/ui-icon-utility-16-electricity.svg';
import { ReactComponent as GasLogo } from 'assets/icons/ui-icon-utility-16-gas.svg';
import { ReactComponent as GovLogo } from 'assets/icons/ui-icon-utility-16-gov.svg';
import { ReactComponent as TelcoLogo } from 'assets/icons/ui-icon-utility-16-comms.svg';
import { ReactComponent as OtherLogo } from 'assets/icons/ui-icon-utility-16-other.svg';

const UtilityIcons: React.FC<any> = (props: any) => {
  switch (props.type.toLowerCase()) {
    case 'water':
      return <WaterLogo />;
    case 'electric':
      return <ElectricityLogo />;
    case 'gas':
      return <GasLogo />;
    case 'local government':
      return <GovLogo />;
    case 'telco':
      return <TelcoLogo />;
    default:
      return <OtherLogo />;
  }
};
export default UtilityIcons;
